import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppAlertService } from '../../../../shared/services/app-alert/app-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { CoreFileUploadDialogComponent } from './add-file-modal/add-file-modal.component';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { FileApiService } from '../../../../shared/services/file-api/file-api.service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-create-organization-tab-three',
  templateUrl: './create-organization-tab-three.component.html',
  styleUrl: './create-organization-tab-three.component.scss',
})
export class CreateOrganizationTabThreeComponent implements OnInit {
  @Output() tabThreeValueForm = new EventEmitter();
  mode: 'create' | 'edit' | undefined;
  @ViewChild('organizationFileUploadDialog')
  fileUploadDialog: CoreFileUploadDialogComponent;

  uploadedFile: any;

  fileForm: FormGroup;

  orgId: number | null = null;

  initialFormValues = {
    uploadedFiles: [],
    editModeUploadedFiles: [],
  };

  fileError: string | null = null;
  selectedFile: any;
  signedUser: any = null;
  token: string;
  constructor(
    private readonly fb: FormBuilder,
    private readonly appAlertService: AppAlertService,
    private readonly translate: TranslateService,
    private readonly authService: AuthService,
    private readonly fileApiService: FileApiService
  ) {
    this.fileForm = this.fb.group({
      uploadedFiles: [],
      editModeUploadedFiles: [],
    });
    this.signedUser = this.authService.getUserData();
    this.token = this.authService.getToken() ?? '';
  }

  async initialize(data: any) {
    //eğer
    if (data) {
      this.mode = 'edit';
      this.orgId = data?.id;
      this.fileForm.patchValue({
        uploadedFiles: data?.organizationFiles,
        editModeUploadedFiles:
          this.fileForm.controls['editModeUploadedFiles']?.value ?? [],
      });
    } else {
      this.mode = 'create';
      this.orgId = null;
      this.fileForm.patchValue({
        uploadedFiles: [],
        editModeUploadedFiles: [],
      });
    }
  }

  ngOnInit(): void {
    this.fileForm.valueChanges.subscribe((val) => {
      this.tabThreeValueForm.emit(val);
    });
  }

  openUploadDialog() {
    this.fileUploadDialog.initialize(this.fileForm.value.uploadedFiles);
  }

  onSaveFile(event: any) {
    if (this.orgId) {
      const uploadedFiles = this.fileForm.get('uploadedFiles')?.value || [];
      this.fileForm.get('uploadedFiles')?.setValue([...uploadedFiles, event]);

      const editFiles = this.fileForm.get('editModeUploadedFiles')?.value || [];
      this.fileForm.get('editModeUploadedFiles')?.setValue([...editFiles, event]);
    } else {
      const uploadedFiles = this.fileForm.get('uploadedFiles')?.value || [];
      if (Array.isArray(uploadedFiles)) {
        this.fileForm.get('uploadedFiles')?.setValue([...uploadedFiles, event]);
      }
    }
  }

  onClickDownload(file: any) {
    this.fileApiService
      .getFileBlob(file.fileUrl, this.token)
      .subscribe((blob) => {
        saveAs(blob, file.fileName);
      });
  }

  onClickDelete(index: number) {
  const uploadedFiles = [...(this.fileForm.controls['uploadedFiles']?.value ?? [])];
  const deletedItem = uploadedFiles[index];
  uploadedFiles.splice(index, 1);
  this.fileForm.patchValue({ uploadedFiles });

  // Yeni eklenmiş dosyaysa (id'si yoksa) editModeUploadedFiles'dan da sil
  if (this.orgId && deletedItem && !deletedItem.id) {
    const editFiles = [...(this.fileForm.controls['editModeUploadedFiles']?.value ?? [])];
    const editIndex = editFiles.findIndex(f => f.fileName === deletedItem.fileName);
    if (editIndex !== -1) {
      editFiles.splice(editIndex, 1);
      this.fileForm.patchValue({ editModeUploadedFiles: editFiles });
    }
  }
}
  deleteFileConfirm(item:any,index: number): void {
      this.appAlertService.sweetConfirm({
        header: `${item.fileName}`,
        message: `${this.translate.instant('general.is-delete')} ${
          item.fileName
        }?`,
        showCloseButton: true, 
        accept: () => this.onClickDelete(index),
        reject: () => {},
      });

  }

  showFileCreator(createdBy: any): string {
  let userInfo = '';

  if (!this.orgId && this.signedUser) {
    userInfo = `${this.signedUser.firstName ?? ''} ${this.signedUser.lastName ?? ''}`.trim();
  } else if (createdBy) {
    userInfo = `${createdBy.firstName ?? ''} ${createdBy.lastName ?? ''}`.trim();
  }

  return userInfo;
}


  deleteEditModeUploadedFiles(index: number) {
    let array = this.fileForm.controls['editModeUploadedFiles']?.value ?? [];
    array.splice(index,1);

    this.fileForm.patchValue({
      editModeUploadedFiles: array,
    });
  }

  resetForm() {
    this.fileForm.setValue({
      uploadedFiles: [],
      editModeUploadedFiles: [],
    });
  }
}
